import { render, staticRenderFns } from "./E-4_NewsCenter_EditPageTitle.vue?vue&type=template&id=270c7f75&"
import script from "./E-4_NewsCenter_EditPageTitle.vue?vue&type=script&lang=js&"
export * from "./E-4_NewsCenter_EditPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSpacer,VTextField})
